import React from "react";
import "../../Components/Menu/Menu.css";

export default function Analysis() {
  return (
    <div>
      <h4 className="sub-title">Analyse, statistikk og kommunikasjon </h4>
      <p className="content">
        <p>
          Vi har installert et analyseverktøy i appen for å kunne benytte
          brukerdata til å forbedre appen. Vi sporer anonymt om appen er i bruk,
          hvor lenge den er åpen, hva slags telefon du har, hvilke sider du
          bruker ofte, hvilke funksjonaliteter du benytter deg av, om sidene
          fungerer som de skal, hvilket operativsystem som er i bruk og om appen
          slettes.
        </p>
        <p>
          Vi benytter ikke brukerdata for å markedsføre, men når du velger
          tjenester fra leverandørene i Bilista, blir du kunde hos dem, og de
          kan derfor sende deg e-poster og SMS relatert til den kjøpte
          tjenesten.
        </p>
      </p>
    </div>
  );
}
